export default {
  SET_REQUIREMENT_SPECIFICATIONS (state, data) {
    state.requirementSpecifications = data
  }

}
